import React from 'react';
import {arrayOf, bool, node, object, oneOfType} from 'prop-types';
import cx from 'classnames';
import {GlobalHotKeys} from 'react-hotkeys';
import If from '../../misc/If';
import FormStepContext from './FormStepContext';
import FormControls from './FormControls';
import useFormStep from './useFormStep';
import KEY_MAP from '../../../constant/KeyMap';

import './FormStep.css';

const propTypes = {
  children               : oneOfType([arrayOf(node), node]).isRequired,
  hooks                  : object,
  isCentered             : bool,
  showNavigationControls : bool,
  showSkipButton         : bool
};

const defaultProps = {
  hooks                  : {},
  isCentered             : false,
  showNavigationControls : true,
  showSkipButton         : false
};

function FormStep(props) {
  const {
    children,
    hooks,
    isCentered,
    showNavigationControls,
    showSkipButton
  } = props;
  const {formStepContext, handlers} = useFormStep({
    hooks
  });
  const {isStepSubmitted, isStepValid, stepCount} = formStepContext;

  return (
    <FormStepContext.Provider value={formStepContext}>
      <GlobalHotKeys allowChanges handlers={handlers} keyMap={KEY_MAP} />

      <section
        className={cx('form-step', {
          'form-step--is-centerd' : isCentered
        })}
      >
        <If condition={Boolean(stepCount)}>
          <span className="form-step__count" key="step-count">
            <div className="form-step__count-number">
              {stepCount}
            </div>

            <svg className="form-step__count-icon" height="10" width="11">
              <path d="M7.586 5L4.293 1.707 5.707.293 10.414 5 5.707 9.707 4.293 8.293z" fill="currentColor" />
              <path d="M8 4v2H0V4z" fill="currentColor" />
            </svg>
          </span>
        </If>

        {children}

        <FormControls
          isCentered={isCentered}
          isStepSubmitted={isStepSubmitted}
          isStepValid={isStepValid}
          showNavigationControls={showNavigationControls}
          showSkipButton={showSkipButton}
        />
      </section>
    </FormStepContext.Provider>
  );
}

FormStep.propTypes = propTypes;
FormStep.defaultProps = defaultProps;

export default FormStep;
